module.exports = __webpack_public_path__ + "static/media/info03.248386cc.png";